import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[dragDrop]'
})
export class DragDropDirective {

  @Output() callbackFile = new EventEmitter();
  constructor() {
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt){
    evt.preventDefault();
    evt.stopPropagation();
  }
  @HostListener('dragleave', ['$event']) public onDragLeave(evt){
    evt.preventDefault();
    evt.stopPropagation();
  }
  @HostListener('drop', ['$event']) public onDrop(evt){
    evt.preventDefault();
    evt.stopPropagation();
    try {
      let files = evt.dataTransfer.files;
      console.log('DROP', files)
      if(files.length > 0){
        this.callbackFile.emit(files);
      }
    } catch(error) {}
  }

  ngAfterViewInit() {
  }
}



// WEBPACK FOOTER //
// ./src/directives/drag-drop/drag-drop.ts